import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconCloseCircleLine.tsx
const IconCloseCircleLine = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.707 4.706-3.292-3.292-3.294 3.293-1.414-1.414L10.586 12 7.293 8.707l1.414-1.414 3.294 3.293 3.292-3.292 1.414 1.414L13.415 12l3.292 3.292z",
		clipRule: "evenodd"
	})]
});
var IconCloseCircleLine_default = forwardRef(IconCloseCircleLine);
//#endregion
export { IconCloseCircleLine_default as default };
